module.exports = __webpack_public_path__ + "images/job/detail/detail_icon08-d27698c6dfa7f4cd84b3c48fbc723fa0.png";